import Vue from 'vue'
import App from './App.vue'
import VTooltip from 'v-tooltip'
import 'element-ui/lib/theme-chalk/index.css';
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faPlusSquare, faCopy, faExternalLinkAlt, faHourglass,
  faSearch, faQuestion, faBars, faHandPointRight, faExclamationCircle
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faPlusSquare, faCopy, faExternalLinkAlt, faHourglass,
  faSearch, faQuestion, faBars, faHandPointRight, faExclamationCircle);

import ElementUI from 'element-ui';
import itLocale from 'element-ui/lib/locale/lang/it';
import 'element-ui/lib/theme-chalk/index.css';
import { vuexStore } from './store';
import _ from 'lodash';
import { gameStore } from './store/game/store';

Vue.use(ElementUI, { itLocale });
Vue.use(VTooltip);
Vue.component('font-awesome-icon', FontAwesomeIcon);

new Vue({
  render: h => h(App),
  store: vuexStore
}).$mount('#app');

//preload cards
var _cards = [];
for (let index = 0; index < 10; index++) {
  var image1 = new Image(),
    image2 = new Image(),
    image3 = new Image();

  image1.src = `cards/a${_.padStart((index).toString(), 2, "0")}.png`;
  image2.src = `cards/l${_.padStart((index).toString(), 2, "0")}.png`;
  image3.src = `cards/p${_.padStart((index).toString(), 2, "0")}.png`;
  _cards.push(image1);
  _cards.push(image2);
  _cards.push(image3);
}
_cards.push(new Image());
_cards[_cards.length - 1].src = "pics/notebook.png";
_cards.push(new Image());
_cards[_cards.length - 1].src = "pics/cp.png";
_cards.push(new Image());
_cards[_cards.length - 1].src = "pics/cl.png";
_cards.push(new Image());
_cards[_cards.length - 1].src = "pics/ca.png";
_cards.push(new Image());
_cards[_cards.length - 1].src = "cards/unknown.png";


(window as any).gameStore = gameStore;

